<template>
  <a-popover placement="bottomRight" overlayClassName="avatar-popover-overlay" :trigger="['hover']" v-model="visible" @visibleChange="visibleChange">
    <template slot="content">
      <div style="min-width:200px; padding:15px 12px; display:flex; align-items:center;" :style="note">
        <div v-if="userInfo" style="margin-right:10px;border-radius:50%; width:32px; height:32px; font-size:20px; text-align:center; overflow: hidden;" :style="{background: !userInfo.headImgUrl ? '#d1d1d1' : '#fff'}">
          <icon-font class="gb-icon-user" type="gb-icon-user" style="color: #fff;" v-if="!userInfo.headImgUrl" />
          <img :src="userInfo.headImgUrl" style="width:32px; height: 32px; display:block" v-else >
        </div>
        <div style="flex:1;min-width:0;">
          <div style="color:#1E1E28;font-size:14px;font-weight:bold;">{{ userInfo | userName }}</div>
          <div style="color:#484848;font-size:12px;display:flex;align-items:center;">
            <div style="flex:1;min-width:0;">{{ packageName }}</div>
            <div class="btn_login">
              <a style="color:#fff" @click="handleMenuClick({ key:'user' })">
                {{ i18nRender('layouts.upgrade') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- menu -->
      <a-menu
        mode="vertical"
        :selectable="false"
        :openKeys.sync="openKeys"
        @click="handleMenuClick"
        @openChange="handleSubMenuOpenChange"
        @mousemove="handleSubMenuMove"
      >
        <!-- 用户中心 -->
        <a-menu-item key="home">
          <icon-font type="gb-icon-a-01" class="iconFont" />
          <div>{{ i18nRender('layouts.usercenter') }}</div>
        </a-menu-item>
        <!-- 产品套餐 -->
        <a-menu-item key="productPackage">
          <icon-font type="gb-icon-zijinzhushou" class="iconFont" />
          <div>{{ i18nRender('layouts.productPackage') }}</div>
        </a-menu-item>
        <!-- 账号设置 -->
        <a-menu-item key="accountSettings">
          <icon-font type="gb-icon-a-02" class="iconFont" />
          <div>{{ i18nRender('layouts.accountSettings') }}</div>
        </a-menu-item>
        <!-- 权限管理 -->
        <a-menu-item key="authority" v-if="menus.length">
          <icon-font type="gb-icon-a-03" class="iconFont" />
          <div>{{ i18nRender('layouts.authority') }}</div>
        </a-menu-item>
        <!-- 店铺授权 -->
        <a-menu-item key="store" v-if="menus.length">
          <icon-font type="gb-icon-dianpu2" class="iconFont" />
          <div>{{ i18nRender('layouts.store.authorization') }}</div>
        </a-menu-item>
        <!-- 资金助手 -->
        <a-menu-item key="money" v-if="!isDemo && isAppear">
          <icon-font type="gb-icon-zijinzhushou" />
          <div>{{ i18nRender('layouts.MoneyAssistant') }}</div>
        </a-menu-item>
        <!-- 应用市场 -->
        <a-menu-item v-if="!isDemo && systemCode === 'ERP' && !isSellerwell()" key="app" >
          <icon-font style="margin-right: 13px;" type="gb-icon-app-marketplace" />
          <span style=" padding-right: 0">{{ $t('layouts.应用市场') }}</span>
          <span class="safe-new" v-if="localDefaultConfig.appNew" ></span>
        </a-menu-item>
        <!-- 易学堂（直播/回放） -->
        <a-menu-item v-if="!isSellerwell()" key="live">
          <icon-font style="margin-right: 13px;" type="gb-icon-shiliangzhinengduixiang-07" />
          <span style=" padding-right: 0">{{ $t('layouts.易学堂（直播/回放）') }}</span>
        </a-menu-item>
        <!-- 菜单样式 -->
        <a-sub-menu key="syl" popupClassName="avatar-menu-sub-popup">
          <template slot="title">
            <icon-font type="gb-icon-a-04" class="iconFont"  />
            {{ i18nRender('layouts.menusyl') }}
            <icon-font class="rotate anticon-right" type="gb-icon-Down" />
          </template>
          <a-menu-item >
            <a-tooltip placement="left">
              <template slot="title">
                <span>{{ i18nRender('layouts.menusyl.top') }}</span>
              </template>
              <div class="layout-syl-ob-item" @click.stop="saveUseNewMenu(2)">
                <a-icon type="check" v-if="userConfig.packageStyle === '2'" />
                <img src="~@/assets/layout1.png" alt="">
              </div>
            </a-tooltip>
          </a-menu-item>
          <a-menu-item >
            <a-tooltip placement="left">
              <template slot="title">
                <span>{{ i18nRender('layouts.menusyl.left') }}</span>
              </template>
              <div class="layout-syl-ob-item" @click.stop="saveUseNewMenu(1)">
                <a-icon type="check" v-if="userConfig.packageStyle === '1'" />
                <img src="~@/assets/layout2.png" alt="">
              </div>
            </a-tooltip>
          </a-menu-item>
        </a-sub-menu>
        <!-- 语言设置 -->
        <a-sub-menu key="lang" popupClassName="avatar-menu-sub-popup national-popup">
          <template slot="title">
            <icon-font :type="languageCodes[currentLang].icon" class="iconFont" />
            {{ i18nRender('layouts.langset') }}
            <icon-font class="rotate anticon-right" type="gb-icon-Down" />
          </template>
          <a-menu-item class="layout-syl-ob-item-national" :class="{'home-ant-menu-item-active': code === currentLang}" v-for="code in Object.keys(languageCodes)" :key="code">
            <svg class="icon" aria-hidden="true" style="width: 16px; height: 11px">
              <use :xlink:href="`#icon-${languageCodes[code].flag}`"></use>
            </svg>
            {{ languageCodes[code].label }}
          </a-menu-item>
        </a-sub-menu>
        <!-- 退出 -->
        <a-menu-item key="logout">
          <icon-font type="gb-icon-a-05" class="iconFont" />
          <div>{{ i18nRender('layouts.logout') }}</div>
        </a-menu-item>
      </a-menu>
    </template>
    <div class="right-content__action">
      <icon-font class="gb-icon-user" type="gb-icon-user" v-if="!userInfo.headImgUrl"  />
      <img :src="userInfo.headImgUrl" style="width:22px; height: 22px; border-radius: 50%; background: #fff" v-else >
      <span style="margin-left:8px;">{{ userInfo | userName }}</span>
      <icon-font type="gb-icon-Down" style="margin-left: 10px"  />
    </div>
  </a-popover>
</template>

<script>
import { i18nRender } from '@/locales'
import { mapGetters } from 'vuex'
import i18nMixin from '@/store/i18n-mixin'
import { changePackageStyle } from '@/api/sso/user'
import { forward } from '@/api'
import { IS_SELLERWELL } from '@/store/mutation-types'

export default {
  name: 'AvatarDropdown',
  mixins: [i18nMixin],
  data () {
    return {
      note: {
        backgroundImage: 'url(' + require('../../assets/drop-down_box_background.png') + ')'
      },
      MoneyAssistantUrl: '',
      isAppear: false,
      timer: null,
      openKeys: [],
      visible: false,
      languageIcons: {
        'zh_CN': '🇨🇳',
        'zh_TW': '🇭🇰',
        'en_US': '🇺🇸',
        'pt_BR': '🇧🇷',
        'ko_KR': '🇰🇷'
      },
      languageCodes: {
        'zh_CN': {
          label: '简体中文',
          flag: 'CN',
          icon: 'gb-icon-Chinese1'
        },
        'en_US': {
          label: 'English',
          flag: 'US',
          icon: 'gb-icon-English'
        },
        'ko_KR': {
          label: '한국어',
          flag: 'hanguo',
          icon: 'gb-icon-Korean'
        }
      }
    }
  },
  filters: {
    userName (userInfo) {
      return userInfo
        ? userInfo.userRealName || userInfo.realName || userInfo.nickName || userInfo.userName
        : '用户姓名'
    }
  },
  computed: {
    ...mapGetters([
      'userConfig',
      'menus',
      'isDemo',
      'userInfo',
      'systemCode',
      'currentLang',
      'localDefaultConfig'
    ]),
    packageName () {
      const { systemCode } = this.$route.params
      const { microApps } = this.$store.getters
      const currentApp = systemCode === 'ERP'
        ? microApps.find(item => item.systemCode === 'ORDER_MANAGER')
        : microApps.find(item => item.systemCode === systemCode)

      return currentApp?.packageName || '-'
    }
  },
  // watch: {
  //   userInfo: {
  //     handler: 'changeLang',
  //     immediate: true
  //   }
  // },
  mounted () {
    this.forward()
  },
  methods: {
    i18nRender,
    handleMenuClick ({ key: action }) {
      if (Object.keys(this.languageCodes).includes(action)) {
        return this.changeLang({ key: action })
      }
      if (this.$store.getters.isDemo) {
        this.$message.warning(this.$t('layouts.demo.tips'))
        return
      }
      this[action]()
    },
    money () {
      window.open(this.MoneyAssistantUrl, '_blank')
    },
    live () {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/helper/live-roadcast`
      })
    },
    app () {
      this.$store.dispatch('SetLocalDefaultConfig', {
        appNew: false
      })
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/app/home`
      })
    },
    forward () {
      forward({}).then(res => {
      if (res.data) {
        const data = JSON.parse(res.data?.respBody || '{}')
        this.MoneyAssistantUrl = data?.url || ''
        if (data?.authStatus === 1) {
          this.isAppear = true
        }
      }
    })
    },
    user () {
      // this.$winOpen('/#/company/serve/buy-serve')
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        // menuName: {
        //   zh_CN: '购买服务',
        //   en_US: 'User Center',
        //   ko_KR: '사용자 센터'
        // },
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/serve/buy-serve`
      })
    },
    home () {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        menuName: {
          zh_CN: '用户中心',
          en_US: 'User Center',
          ko_KR: '사용자 센터'
        },
        path: `/entry/${serviceId}/${systemCode}/sso-web#/embel/home`
      })
    },
    productPackage () {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        ignore: true,
        path: `/entry/${serviceId}/${systemCode}/sso-web#/user/product-package`,
        menuName: {
          zh_CN: '产品套餐',
          en_US: 'Product Package',
          ko_KR: '상품 패키지'
        }
      })
    },
    logout () {
      this.$confirm({
        title: i18nRender('logout.title'),
        content: i18nRender('logout.content'),
        okText: i18nRender('logout.okText'),
        okType: 'danger',
        cancelText: i18nRender('logout.cancelText'),
        onOk: () => {
          this.$store.dispatch('Logout')
        }
      })
    },
    authority () {
      const { params: { serviceId, systemCode } } = this.$route
      const pushPane = (data) => {
        const systemName = this.$store.getters.microApps.find(item => item.systemCode === data.systemCode)?.name || 'iframe'
        const pane = {
          ...data,
          systemName
        }
        if (data.path || data.key) {
          pane.path = `/entry/${serviceId}/${systemCode}/${systemName}#${data.path || '/m_' + data.key}`
        }
        this.$store.dispatch('entry/SetActiveAsync', pane)
      }
      pushPane({
        path: `/embel/list`,
        systemCode: 'SSO_SYS_USER'
      })
      // * external
      // pushPane({
      //   external: true,
      //   menuUrl: 'http://kaifa2019.eccang.com/purchase/purchase-opration/create-purchase',
      //   path: 'b110bcb91fedc60d2e47c6d1083310e7',
      //   menuName: {
      //     zh_CN: '创建采购单2',
      //     en_US: '创建采购单'
      //   },
      //   key: 'b110bcb91fedc60d2e47c6d1083310e7'
      // })
      // * external2
      // pushPane({
      //   external: true,
      //   menuUrl: 'http://localhost:9000/#/company/helper/center',
      //   path: 'WEEKLY_OPERATION_REPORT',
      //   menuParams: {
      //     platformCodeBind: 'WEEKLY_OPERATION_REPORT'
      //   },
      //   menuName: {
      //     zh_CN: 'help center',
      //     en_US: 'help center En'
      //   },
      //   key: `${+new Date()}`
      // })
      // * ignore
      // pushPane({
      //   menuName: {
      //     zh_CN: '购买'
      //   },
      //   ignore: true,
      //   path: `/company/serve/buy-serve?systemCode=TMS`,
      //   systemCode: 'SSO_SYS_USER'
      // })
      // * functionClass
      // pushPane({
      //   functionClass: 'SHOPAUTH_PLATFORM_AUTHORIZATION'
      // })
    },
    store () {
      this.$store.dispatch('entry/SetActiveAsync', {
        functionClass: 'SHOPAUTH_PLATFORM_AUTHORIZATION'
      })
    },
    accountSettings () {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/user/basics-info`
      })
    },
    changeLang ({ key, chooseLanguage } = {}) {
      this.setLang(key || chooseLanguage || 'zh_CN')
      this.visible = false
      clearTimeout(this.timer)
    },
    handleSubMenuOpenChange (openKeys) {
      this.timer = setTimeout(() => {
        const domList = document.querySelectorAll('.avatar-menu-sub-popup')
        let flag = false
        for (var dom of domList) {
          if (dom.style.display !== 'none') {
            flag = true
            break
          }
        }
        this.visible = flag
      }, 450)
    },
    visibleChange () {
      if (this.visible) return
      const domList = document.querySelectorAll('.avatar-menu-sub-popup')
      let flag = false
      for (var dom of domList) {
        if (dom.style.display !== 'none') {
          flag = true
          break
        }
      }
      this.visible = flag
    },
    handleSubMenuMove () {
      clearTimeout(this.timer)
    },
    // 修改顶部样式风格
    saveUseNewMenu (styleCode) {
      changePackageStyle({ styleCode }).then(() => {
        window.location.reload()
      })
    },
    isSellerwell () {
      return IS_SELLERWELL
    }
  }
}
</script>

<style lang="less">
.avatar-popover-overlay {
  .@{ant-prefix}-popover-arrow {
    top: -7px !important;
    border-top-color: #DCE5F4 !important;
    border-left-color: #DCE5F4 !important;
  }
  .@{ant-prefix}-popover-inner {
    margin-top: -14px;
  }
  .@{ant-prefix}-popover-inner-content {
    padding: 0;
    width: 240px;
    position: relative;
    font-size: 12px;
    .@{ant-prefix}-menu-item, .@{ant-prefix}-menu-submenu {
      display: flex;
      margin: 0 !important;
      align-items: center;
      height: 46px !important;
      line-height: 1;
      color: #333 !important;
      font-size: 12px !important;
      .@{ant-prefix}-menu-submenu-title {
        font-size: 12px !important;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex: 0 0 100%;
        align-items: center;
        height: 46px;
        margin: 0;
      }
      .anticon-right {
        margin-left: auto;
        margin-right: 0;
      }
    }
    .@{ant-prefix}-menu-item:hover,
    .@{ant-prefix}-menu-submenu-active .@{ant-prefix}-menu-submenu-title {
      background: #F0F7FF;
    }
  }
  .@{ant-prefix}-menu-submenu-arrow {
    display: none;
  }
  .@{ant-prefix}-menu-sub:hover {
    .@{ant-prefix}-menu-item {
      background: transparent !important;
    }
  }
}

.national-popup .layout-syl-ob-item-national {
  font-size: 12px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  svg {
    margin-right: 10px;
  }
}

.layout-syl-ob-item {
  position: relative;
  text-align: center;
  svg {
    margin-right: 0 !important;
  }
  i {
    text-align: center;
    color: #5782F4;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -30%);
    margin: 0 !important;
    font-size: 16px;
  }
}

</style>

<style lang="less" scoped>
.right-content__action .gb-icon-user {
  display: inline-block;
  background: rgba(255,255,255,.2);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
}
.iconFont {
  font-size: 17px !important;
}
.rotate {
  transform-origin: center;
  transform: rotate(-90deg);
}
.btn_login:hover {
  background: #007BFC;
}
.btn_login {
  padding: 0 13px;
  height: 20px;
  background: linear-gradient(0deg, #A1A7C4 0%, #8B90AF 100%);
  border-radius: 10px;
}
.safe-new {
  position: relative;
  top: -5px;
  font-size: 12px;
  margin-left: -10px;
  margin-top: -8px;
  color: #fff;
  background: #FF001B;
  height: 16px;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  border-radius: 20px;
  &::before {
    content:  'new';
    transform: translate(0, -2px);
  }
}
</style>
